var _path;

import * as React from "react";

function SvgEuro(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.261 34.471l-.464-2.1a.863.863 0 00-1.036-.65 14.26 14.26 0 01-3.192.386c-4.68 0-8.358-2.821-9.872-6.957h9.25a.85.85 0 00.836-.686l.357-1.714a.853.853 0 00-.836-1.029H15.733c-.107-1.15-.15-2.307-.043-3.428h11.607a.85.85 0 00.836-.679l.364-1.714a.855.855 0 00-.836-1.036H16.44c1.5-4.171 5.178-7 10-7 1.05 0 2.064.15 2.729.272a.856.856 0 00.985-.622l.564-2.114a.856.856 0 00-.67-1.064A19.88 19.88 0 0026.525 4C19.383 4 13.69 8.579 11.819 14.857H9.575a.86.86 0 00-.857.857v1.715a.86.86 0 00.857.857h1.65c-.086 1.128-.072 2.535.028 3.428H9.576a.86.86 0 00-.857.857v1.715a.86.86 0 00.857.857h2.3C13.733 31.479 19.26 36 26.519 36c1.742 0 3.242-.3 4.107-.514a.856.856 0 00.635-1.015z"
  })));
}

export default SvgEuro;